<template>
<main class="L_BasketCompHolder">
    <div class="vld-parent">
        <loading :active.sync="IsLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="fullPage" :color="'#F3CBBB'"></loading>
    </div>
    <div class="G_DisplayColumnNowrap L_BasketItemsHolder" v-if="!BasketEmpty">
        <div class="G_DisplayRowNowrap G_BorderRadius L_BasketItem" v-for="(BasketItem, Index) in BasketItems" :key="Index">
            <div class="G_BorderRadius L_BasketImageHolder" :style="{ backgroundImage: 'url(\''+BasketItem.ImagePath+'\')' }">

            </div>
            <div class="G_DisplayColumnNowrap L_BasketItemInfoHolder">
                <div class="G_NormalFont G_DisplayColumnNowrap L_BasketItemName">
                    {{ BasketItem.Description }} - R {{ BasketItem.Price }}
                </div>
                <div class="G_DisplayRowNowrap L_AddRemoveHolder">
                    <div class="G_DisplayRowNowrap L_AddRemoveIcon">
                        <span class="fa L_RemoveIcon" @click="RemoveBasketItem(BasketItem, Index)">&#xf014;</span>
                    </div>
                    &emsp;
                    <div class="G_DisplayRowNowrap L_AddRemoveIcon">
                        <input class="G_NormalFont L_AddInput" type="number" min="1" max="500" v-model="BasketItem.Qty" @change="SetTotalPrice()">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="G_BorderRadius L_BasketRecieptHolder" v-if="!BasketEmpty">
        <div class="G_DisplayRowNowrap G_NormalFont L_BasketRecieptHeading">
            <span class="G_HeadingFont">Total Price:</span>&nbsp;<span style="margin-top: .2rem;">R {{ TotalPrice }}</span>
        </div>
        <div class="G_DisplayColumnNowrap L_BasketInfoHolder">
            <input class="G_Input G_BorderRadius G_NormalFont G_BorderBlack L_Input" placeholder="Name" v-model="ContactDetails.Name" />
            <input class="G_Input G_BorderRadius G_NormalFont G_BorderBlack L_Input" placeholder="Number" v-model="ContactDetails.Number" />
            <div class="G_NormalFont">You will be contacted in regards to recieving/picking up of the order.</div>
            <div class="G_NormalFont">Pickup (ready only within 72 hours).</div>
        </div>
        <div class="G_DisplayRowNowrap G_NormalFont L_SubmitCancelHolder">
            <div class="G_DisplayRowNowrap G_BorderRadius L_SubmitCancelButton" @click="SubmitOrder()">Submit</div>
            <div class="G_DisplayRowNowrap G_BorderRadius L_SubmitCancelButton" @click="CancelOrder()">Cancel</div>
        </div>
    </div>
    <div class="G_DisplayColumnNowrap L_EmptyCartHolder" v-if="BasketEmpty">
        <div class="fa fa-shopping-basket" style="font-size: 10rem;color: #F3CBBB;margin-bottom: 2rem;"></div>
        &emsp;
        <div class="G_HeadingFont">No items in cart!</div>
    </div>
</main>
</template>

<script>
import firebase from 'firebase/compat/app'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'

export default {
    components: {
        Loading
    },
    data() {
        return {
            BasketItems: [],
            BasketEmpty: true,
            TotalPrice: 0,
            ContactDetails: {
                Name: "",
                Number: ""
            },
            OrderStatus: false,
            fullPage: true,
            IsLoading: false
        }
    },
    created() {
        if (window.localStorage.getItem("BasketItems") != "undefined") this.BasketItems = JSON.parse(window.localStorage.getItem("BasketItems"))

        if (this.BasketItems) {
            if (this.BasketItems) this.BasketEmpty = false
            if (this.BasketItems.length == 0) this.BasketEmpty = true
        }

        this.SetTotalPrice()
    },
    methods: {
        SetTotalPrice() {
            var TotalPriceTemp = 0

            for (var BasketItem in this.BasketItems) {
                TotalPriceTemp += parseInt(this.BasketItems[BasketItem].Qty) * this.BasketItems[BasketItem].Price
            }

            this.TotalPrice = TotalPriceTemp
        },
        RemoveBasketItem(BasketItemDelete, Index) {
            this.BasketItems.splice(Index, 1)
            if (this.BasketItems) {
                if (!this.BasketItems || this.BasketItems.length == 0 && this.BasketItems != "undefined") this.BasketEmpty = true
            }

            window.localStorage.setItem("BasketItems", JSON.stringify(this.BasketItems))

            this.SetTotalPrice()

            this.$emit("UpdateBasket", this.BasketItems)
        },
        SubmitOrder() {
            var Error = ""

            if (!this.IsNumber(this.ContactDetails.Number) || this.ContactDetails.Number.length != 10 || this.IsEmpty(this.ContactDetails.Number)) Error += "Please insert a valid number.\n"
            if (this.IsEmpty(this.ContactDetails.Name)) Error += "Please insert a valid name."

            if (!this.IsEmpty(Error)) {
                alert(Error)
                return
            } else this.IsLoading = true

            var OrderNumber = this.CreateOrderNumber(6)
            var scope = this
            var DB = firebase.firestore()
            DB.collection("order")
                .add({
                    basket_items: this.BasketItems,
                    client_details: this.ContactDetails,
                    order_number: OrderNumber
                })
                .then(data => {
                    scope.OrderStatus = true
                })
                .catch((error) => {
                    scope.OrderStatus = false
                })

            setTimeout(() => {
                if (scope.OrderStatus) {
                    scope.$emit("SetSelectedComp", "Order Successful", scope.BasketItems, OrderNumber, scope.ContactDetails)
                } else {
                    alert("Order did not process, please click on 'Submit' again.")
                    scope.IsLoading = false
                }
            }, 3000);
        },
        CancelOrder() {
            window.localStorage.removeItem("BasketItems")
            this.BasketEmpty = true
            this.BasketItems = {}
            this.$emit("UpdateBasket", this.BasketItems)
        },
        IsNumber(Num) {
            var ValidChars = "0123456789";
            var IsNumber = true;
            var Char;
            for (var i = 0; i < Num.length && IsNumber == true; i++) {
                Char = Num.charAt(i);
                if (ValidChars.indexOf(Char) == -1) IsNumber = false;
            }

            return IsNumber;
        },
        IsEmpty(Val) {
            if (!Val) return true;
            if (typeof Val == "object" && Object.keys(Val).length === 0) return true;
            if (typeof Val == "array" && Val.length === 0) return true;
            return false;
        },
        CreateOrderNumber(Length) {
            var Result = ""
            var Chars = "0123456789101112131415ABCDEFGHIJKLMNOPQRSTUVWXYZ"
            var CharsLength = Chars.length
            for (var i = 0; i < Length; i++) {
                Result += Chars.charAt(Math.floor(Math.random() * CharsLength))
            }

            return Result
        },
        onCancel() {}
    }
}
</script>

<style lang="scss">
@import "../../../assets/GlobalCss.scss";

.L_BasketCompHolder {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    margin-top: 2rem;
    margin-bottom: 2rem;

    @include mobile() {
        flex-flow: column nowrap;
        align-items: center;
    }
}

.L_BasketItemsHolder {
    width: 60%;
    height: 100%;
    justify-content: space-around;
    align-items: center;

    @include mobile() {
        width: 100%;
    }
}

.L_BasketItem {
    width: 90%;
    height: 10rem;
    box-shadow: 1px 1px 8px 0px #000000BF;
    margin-bottom: 2rem;
    padding: 1rem;
}

.L_BasketImageHolder {
    width: 30%;
    height: 100%;
    background-size: 100% 100%;
}

.L_BasketItemInfoHolder {
    width: 70%;
    height: 100%;
    padding-left: 1rem;
}

.L_BasketItemName {
    width: 100%;
    height: 80%;
}

.L_AddRemoveHolder {
    width: 100%;
    height: 20%;
    justify-content: flex-end;
}

.L_AddRemoveIcon {
    width: 20%;
    height: 100%;
    justify-content: center;
    align-items: center;
}

.L_RemoveIcon {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    color: rgb(243, 203, 187);
    border-radius: 0.5rem;
}

.L_RemoveIcon:hover {
    background-color: #F3CBBB;
    transition: .3s;
    border: solid #ffffff 0.1rem;
    color: white;
    cursor: pointer;
}

.L_AddInput {
    font-size: 2rem;
    border-radius: 0.5rem;
    border: solid #F3CBBB 0.1rem;
}

.L_BasketRecieptHolder {
    width: 25%;
    height: 30rem;
    box-shadow: 1px 1px 8px 0px #000000BF;
    padding: 1rem;

    @include mobile() {
        width: 90%;
        height: 20rem;
    }
}

.L_BasketRecieptHeading {
    width: 100%;
    height: 10%;
    align-items: center;
    justify-content: center;
}

.L_BasketInfoHolder {
    width: 100%;
    height: 60%;
    align-items: center;
    justify-content: space-around;
    text-align: center;
}

.L_Input {
    border: solid #f3cbbb 0.1rem;
}

.L_SubmitCancelHolder {
    width: 100%;
    height: 20%;
    justify-content: space-around;
    align-items: center;
}

.L_SubmitCancelButton {
    width: 20%;
    height: 50%;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    background-color: #F3CBBB;
    cursor: pointer;
}

.L_SubmitCancelButton:hover {
    transition: .2s ease;
    background-color: #CDAA9C;
    color: #FFFFFF;
}

.L_EmptyCartHolder {
    width: 100%;
    height: 20rem;
    justify-content: center;
    align-items: center;
}
</style>
